import DashboardWithSidebar from './DashboardWithSidebar';

export default DashboardWithSidebar;
